import { create } from "zustand";

type ConsentStatus = "pending" | "accepted" | "rejected";

const STORAGE_KEY = "loyrush-cookie-consent";

interface CookieConsentState {
  status: ConsentStatus;
  accept: () => void;
  reject: () => void;
}

export const useCookieConsentStore = create<CookieConsentState>((set) => ({
  status: (localStorage.getItem(STORAGE_KEY) as ConsentStatus) || "pending",

  accept: () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    set({ status: "accepted" });
  },

  reject: () => {
    localStorage.setItem(STORAGE_KEY, "rejected");
    set({ status: "rejected" });
  },
}));
